export default (category) => {
  const filterAggs = (agg) => agg.buckets;

  return [
    ...category.aggs.filter(filterAggs),
    ...category.features.filter(filterAggs),
  ];
};
